import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelFactory } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import UnitEditor from "./UnitEditor.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  tf
} = I18N.ns('ui-attributes.condition.comparator.type.unit.UnitGreaterThanComparatorEditor');
export default function UnitGreaterThanComparatorEditor(props) {
  const {
    value,
    attribute,
    suggestor,
    usage
  } = props;
  const Model = ModelFactory.get(value);
  const onModelChange = useValueChange(Model, props);
  const value1 = Model.getValue1(value);
  return /*#__PURE__*/_jsx(UnitEditor, {
    usage: usage,
    variant: "conditionSelector",
    suggestor: suggestor,
    attribute: attribute,
    value: value1,
    onChange: onModelChange,
    eventData: "setValue1"
  });
}
const getSelectedName = tf('selectedName');
function createFor(unitType) {
  const editor = props => {
    return UnitGreaterThanComparatorEditor({
      ...props,
      unitType
    });
  };
  editor.isInline = true;
  editor.getSelectedName = getSelectedName;
  return editor;
}
UnitGreaterThanComparatorEditor.createFor = createFor;